import { Show } from "solid-js";

interface PaginationProps {
  page: number;
  totalPages: number;
  perPage: number;
  total: number;
  loading: boolean;
  onPageChange: (page: number) => void;
  onPerPageChange: (perPage: number) => void;
}

export function Pagination(props: PaginationProps) {
  return (
    <Show when={props.total > 0}>
      <div class="flex items-center justify-between text-xs text-gray-500 mt-3">
        <div class="flex items-center gap-2">
          <span>{props.total} total</span>
          <select
            value={props.perPage}
            onChange={(e) => props.onPerPageChange(Number(e.currentTarget.value))}
            class="bg-gray-800 border border-gray-700 rounded px-2 py-0.5 text-xs text-gray-200 cursor-pointer"
          >
            <option value={10}>10 / page</option>
            <option value={20}>20 / page</option>
            <option value={50}>50 / page</option>
            <option value={100}>100 / page</option>
          </select>
        </div>
        <div class="flex items-center gap-3">
          <span>Page {props.page} of {props.totalPages || 1}</span>
          <div class="flex gap-1">
            <button
              onClick={() => props.onPageChange(props.page - 1)}
              disabled={props.page <= 1 || props.loading}
              class="rounded border border-gray-700 px-2 py-0.5 text-xs hover:bg-gray-800 disabled:opacity-40 cursor-pointer"
            >
              Prev
            </button>
            <button
              onClick={() => props.onPageChange(props.page + 1)}
              disabled={props.page >= props.totalPages || props.loading}
              class="rounded border border-gray-700 px-2 py-0.5 text-xs hover:bg-gray-800 disabled:opacity-40 cursor-pointer"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </Show>
  );
}
